import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import IconButton from '@mui/material/IconButton'
import React from 'react'

const CollapseArrowIcon = ({ toggle, setToggle, className, disabled }) => {
  const toggleHandler = () => {
    setToggle(!toggle)
  }

  const iconButtonProps = {
    'aria-label': 'expand row',
    'size': 'small',
    ...(className && { className }),
    ...(!disabled && setToggle && { onClick: toggleHandler })
  }

  return (
    <IconButton {...iconButtonProps}>
      {disabled ? (
        <KeyboardArrowDownIcon />
      ) : toggle ? (
        <KeyboardArrowUpIcon />
      ) : (
        <KeyboardArrowDownIcon />
      )}
    </IconButton>
  )
}

export default CollapseArrowIcon
